// Module / plugin names as they appear in organization.allModules
// (checked via TokenStorageService.hasModule)
// QR-menu plugin: a sub-module of «Меню» (resto-menu) whose name === linkName,
// so the same string serves hasModule() and the `restaurant/qr-menu` route's
// data.moduleName (matched by linkName in privilegeGuard / moduleBlockedGuard).
// Also gates the «QR-меню» sales channel (QR_MENU): the product/dish toggles
// and the bulk «Каналы продаж» checkbox.
export const QR_MENU_MODULE = 'qr-menu';

// Restaurant tech-cards / recipes module (resto-position-select glass block).
export const FOOD_RECIPES_MODULE = 'food-recipes';

// Client loyalty / cashback module (gates the cashback-group auto-assign toggle).
export const LOYALTY_PROGRAM_MODULE = 'loyalty-program';

// Open-bank integration module (gates creating an OPEN_BANK fin-account).
export const BANK_INTEGRATIONS_MODULE = 'bank-integrations';

/**
 * Multipricing («Прайс-листы по филиалам») plugin: gates the `multipricing`
 * routes and the price-list column of the branch dialog. Checked via
 * `TokenStorageService.hasModuleLink` (by `linkName`, tree-wide) — NOT via
 * `hasModule`. An org gets it either bundled in its tariff (RESTO MAX today) or
 * by buying the plugin.
 */
export const MULTIPRICING_MODULE = 'multipricing';

// EDI (Didox) integration plugin: gates the didox route and the "Загрузить с ЭДО"
// button on the purchase page. The backend delivers it with `name` === `linkName`,
// so this single string works both for route data.moduleName (matched by linkName)
// and for BuyPlugins highlightName (matched by name).
export const EDI_INTEGRATION_MODULE = 'edi-integration';

// Restaurant modificators (modification groups) module — gates the
// modificators page and the modificators tab in the food dialog.
export const MODIFICATORS_MODULE = 'modificators';

// Доставка: модуль раздела доставки (роуты delivery/*, баннер WEBSITE) и
// переключатели «Показывать в Uzum Tezkor» / «Показывать в Yandex Eats»
// (enabledAggregators: UZUM_TEZKOR / YANDEX_EATS) в диалогах товара и блюда.
// «Показывать на сайте доставки» требует ещё и ONLINE_ORDERING_MODULE
// (CHANNEL_MODULES в common/utils/aggregators.ts).
export const DELIVERY_MODULE = 'delivery';

// Сайт доставки (онлайн-заказы): плагин гейтит вкладку «Сайт доставки» в
// настройках доставки и, вместе с DELIVERY_MODULE, переключатель «Показывать
// на сайте доставки» в диалогах товара и блюда (CHANNEL_MODULES в
// common/utils/aggregators.ts). name === linkName, как у остальных плагинов.
export const ONLINE_ORDERING_MODULE = 'online-ordering-service';

// Noor (внешняя служба доставки): плагин гейтит карточку Noor во вкладке
// «Интеграции» настроек доставки (delivery-integrations). name === linkName,
// как у остальных плагинов.
export const NOOR_DELIVERY_MODULE = 'delivery-service-noor';

// ИИ-перевод: плагин гейтит всё, что ходит в api/integration/translate, —
// перевод и генерацию описания (features/forms/translate-button) и «Перевести
// каталог» в учётной политике. Мультиязычные поля работают и без него.
// name === linkName, как у остальных плагинов.
export const AI_TRANSLATE_MODULE = 'ai-translate';

// Темы QR-меню: платные шаблоны оформления (все, кроме «Стандартный») на
// странице QR-меню (resto-appearance). Как у edi-integration: бэк отдаёт
// плагин с name === linkName, так что одна строка и для hasModule(), и для
// BuyPlugins highlightName.
export const QR_MENU_THEMES_MODULE = 'qr-menu-themes';

// Действия QR-меню: платные переключатели «Вызов официанта» и «Счёт» на
// странице QR-меню (resto-appearance). name === linkName, как у остальных
// плагинов — одна строка для hasModule() и BuyPlugins highlightName.
export const QR_MENU_ACTIONS_MODULE = 'qr-menu-actions';

// QR-заказ: платные переключатели «Заказ из меню» и «Создание заказа» на
// странице QR-меню (resto-appearance). name === linkName, как у остальных.
export const QR_MENU_ORDER_MODULE = 'qr-menu-order';

// Варианты позиции: плагин гейтит конструктор вариантов
// (features/variants/variants-builder) — вкладку «Варианты» в диалогах товара и
// блюда закрывает стекло. name === linkName, как у остальных плагинов.
export const POSITION_VARIATIONS_MODULE = 'position-variations';

// Telegram-бот организации: плагин гейтит карточку бота во вкладке «Сайт
// доставки» настроек доставки (delivery-telegram-bot) — без него стекло.
// name === linkName, как у остальных плагинов.
export const ORDER_TELEGRAM_BOT_MODULE = 'order-telegram-bot';

/**
 * SMS campaigns plugin (counted): gates the `sms` route and the sidebar entry.
 * The backend delivers it with `name` === `linkName` === 'sms'; the purchased
 * count is the org's monthly SMS allowance (see /api/sms/allowance).
 */
export const SMS_MODULE = 'sms';
